module.exports = __webpack_public_path__ + "static/media/IMG_3478_sm.4093b1d3.jpg";